import React from "react";

function ConfirmDigitalRx() {
  return <div>ConfirmDigitalRx</div>;
}

export default ConfirmDigitalRx;
